import React, { useState } from "react";
import PanelHead from "../../Panel/PanelHead";
import PanelBody from "../../Panel/PanelBody";
import { FormAddRichTextTemplate } from "./FormAddRichTextTemplate";
import { FormAddStructuredTemplate } from "./FormAddStructuredTemplate";

export const PanelAddEmailTemplate = () => {
    const [templateType, setTemplateType] = useState(null);

    const handleTypeSelect = (type) => {
        setTemplateType(type);
    };

    const goBack = () => {
        setTemplateType(null);
    };

    return (
        <div>
            <PanelHead
                title={
                    <div className="flex items-center justify-between w-full gap-4">
                        <div>
                            {templateType
                                ? `Add ${templateType === "rich_text" ? "Rich Text" : "Structured"} Email Template`
                                : "Add Email Template"}
                        </div>
                        {templateType && (
                            <button
                                onClick={goBack}
                                className="text-blue-500 hover:text-blue-700 text-sm font-medium"
                            >
                                ← Back to Type Selection
                            </button>
                        )}
                    </div>
                }
            />
            <PanelBody
                content={
                    !templateType ? (
                        <TemplateTypeSelector onSelectType={handleTypeSelect} />
                    ) : templateType === "rich_text" ? (
                        <FormAddRichTextTemplate />
                    ) : (
                        <FormAddStructuredTemplate />
                    )
                }
            />
        </div>
    );
};

const TemplateTypeSelector = ({ onSelectType }) => {
    return (
        <div className="p-6">
            <h2 className="text-xl font-semibold mb-6 text-center">
                Select Email Template Type
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto">
                <div
                    className="border rounded-lg p-6 cursor-pointer hover:shadow-md transition-shadow text-center"
                    onClick={() => onSelectType("rich_text")}
                >
                    <div className="bg-blue-100 text-blue-800 p-4 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h7" />
                        </svg>
                    </div>
                    <h3 className="font-medium text-lg mb-2">Rich Text Template</h3>
                    <p className="text-gray-600 text-sm">
                        Create templates with a rich text editor, perfect for custom formatting and styling.
                    </p>
                    <button className="mt-4 bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md text-sm">
                        Select
                    </button>
                </div>

                <div
                    className="border rounded-lg p-6 cursor-pointer hover:shadow-md transition-shadow text-center"
                    onClick={() => onSelectType("structured")}
                >
                    <div className="bg-green-100 text-green-800 p-4 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z" />
                        </svg>
                    </div>
                    <h3 className="font-medium text-lg mb-2">Structured Template</h3>
                    <p className="text-gray-600 text-sm">
                        Create templates with structured sections, images, and buttons for consistent layouts.
                    </p>
                    <button className="mt-4 bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-md text-sm">
                        Select
                    </button>
                </div>
            </div>
        </div>
    );
};